import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { PersonaProvider } from "@/lib/persona";
import { AdaptiveProvider } from "@/lib/adaptive";
import { AuthProvider, RequireAdmin } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import CommandPalette from "@/components/CommandPalette";
import OfflineBanner from "@/components/OfflineBanner";
import BackToTop from "@/components/BackToTop";

function App() {
    return (
        <ErrorBoundary>
            <AuthProvider>
                <PersonaProvider>
                    <AdaptiveProvider>
                    <div className="App">
                        <BrowserRouter>
                            <a href="#main" className="sr-only focus:not-sr-only fixed top-2 left-2 z-[300] px-3 py-1 bg-signal text-void font-mono text-xs uppercase tracking-[0.2em]">Skip to content</a>
                            <OfflineBanner />
                            <CommandPalette />
                            <BackToTop />
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/admin/login" element={<AdminLogin />} />
                                <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
                                <Route path="*" element={<NotFound />} />
                            </Routes>
                        </BrowserRouter>
                        <Toaster
                            theme="dark"
                            position="bottom-right"
                            toastOptions={{
                                style: {
                                    background: "#0A0A0A",
                                    border: "1px solid rgba(255,255,255,0.1)",
                                    color: "#F5F5F5",
                                    fontFamily: "JetBrains Mono, ui-monospace, monospace",
                                    fontSize: "12px",
                                },
                            }}
                        />
                    </div>
                    </AdaptiveProvider>
                </PersonaProvider>
            </AuthProvider>
        </ErrorBoundary>
    );
}

export default App;
